import { PayType, type SalaryType } from 'src/types/salaryTypes';

export const PayTypeToSalaryTypeMap: Record<PayType, SalaryType> = {
  [PayType.ANNUAL_PACKAGE]: 'ANNUAL',
  [PayType.ANNUAL_COMMISSION]: 'ANNUAL',
  [PayType.COMMISSION_ONLY]: 'ANNUAL',
  [PayType.MONTHLY]: 'MONTHLY',
  [PayType.HOURLY_RATE]: 'HOURLY',
};

export const SalaryTypeToPayTypeMap: Record<SalaryType, PayType> = {
  ANNUAL: PayType.ANNUAL_PACKAGE,
  MONTHLY: PayType.MONTHLY,
  HOURLY: PayType.HOURLY_RATE,
};
